import type { FC } from 'react';
import { useContext } from 'react';

import { IFLSumDescriptions } from '@src/features/ifl-sum-descriptions';
import { Store } from '@src/store';

export const IFLHouseSumDescriptions: FC = () => {
  const {
    state: {
      stateFormIFLHouse: { insuranceSubproducts },
    },
  } = useContext(Store);

  return <IFLSumDescriptions data={insuranceSubproducts?.subObjects} />;
};
